import React, { forwardRef, SyntheticEvent } from 'react';

import { SearchBtn } from './search-btn';

import * as ST from './styled';

export interface InputValue {
    onClear: () => void,
    onSearch: () => void,
}

interface IProps {
    onClear: () => void,
    onSearch?: () => void,
    isClearBtnHide?: boolean,
    isSearchBtnHide?: boolean,
    isSearchBtnInactive?: boolean,
    [key: string]: any,
}

// eslint-disable-next-line react/display-name
export const SearchInput: React.FC<IProps> = forwardRef((props, ref) => {
    const { onClear, onSearch, isClearBtnHide, isSearchBtnHide, isSearchBtnInactive } = props;

    const clearHandler = (e: SyntheticEvent) => {
        e.stopPropagation();
        if (onClear) {
            onClear();
        }
    };

    const searchHandler = (e: SyntheticEvent) => {
        e.stopPropagation();
        if (onSearch) {
            onSearch();
        }
    };

    return (
        <ST.SearchWrapper>
            <ST.Input
                {...props}
                data-test='search-field'
                ref={ref}
            />
            <ST.BtnWrap>
            {!isClearBtnHide &&
                <ST.ClearBtn
                    onClick={clearHandler}
                />
            }
            {!isSearchBtnHide &&
                <SearchBtn
                    /* @ts-ignore */
                    onClick={(e) => searchHandler(e)}
                    isInactive={isSearchBtnInactive}
                />
            }
            </ST.BtnWrap>
        </ST.SearchWrapper>
    );
});
